/* Native Shopify form submission owns updates and checkout; this only checks quantity rules. */
(() => {
  const validateQuantity = (input) => {
    input.setCustomValidity('');
    const quantity = input.valueAsNumber;
    const minimum = Number(input.dataset.min) || 1;
    if (Number.isFinite(quantity) && quantity > 0 && quantity < minimum) {
      input.setCustomValidity(`The minimum quantity is ${minimum}. Enter 0 to remove this item.`);
    }
  };

  const initialize = (root) => {
    root.querySelectorAll('[data-zc-form]').forEach((form) => {
      if (form.dataset.zcReady) return;
      form.dataset.zcReady = 'true';
      const inputs = [...form.querySelectorAll('[data-zc-quantity]')];
      inputs.forEach((input) => {
        validateQuantity(input);
        input.addEventListener('input', () => validateQuantity(input));
        input.addEventListener('change', () => validateQuantity(input));
      });
      form.addEventListener('submit', (event) => {
        inputs.forEach(validateQuantity);
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
        }
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
